export const INSURERS_LIST = [
  'Agrisano',
  'AMB Assurance SA',
  'Aquilana',
  'Assura-Basis SA',
  'Atupri Gesundheistversicherung AG',
  'Avenir Krakenversicherung AG',
  'Bildende Künstler/Innen',
  'Birchmeier',
  'CONCORDIA',
  'CSS',
  'Easy Sana Krankenversicherung AG',
  'EGK',
  'Einsielder Krankenkasse',
  'GALENOS AG',
  'Gewerbliche',
  'Glamer',
  'Helsana',
  'Hotela',
  'KLuG',
  'KPT',
  'Lumneziana',
  'Luzerner Hinterland',
  'Metallbaufirmen',
  'Mutuel Krankenversicherung AG',
  'Mutuelle Neuchâteloise',
  'ÖKK',
  'Philos Krankenversicherung AG',
  'rhenusana',
  'sana24',
  'sanavals',
  'Sanitas',
  'SLKK',
  'sodalis',
  'Steffisburg',
  'Sumiswalder',
  'SUPRA-1846 SA',
  'SWICA',
  "Vallée d'Entremont",
  'Visana',
  'Visperterminen',
  'vita surselva',
  'Vivacare',
  'Vivao Sympany',
  'Wädenswil',
];

export const NO_INSURER = 'Aucun';
